import React from 'react'
import { useTranslation } from 'lib/i18n'
import config from 'lib/nextConfig'
import { tertiaryBlue700, white } from 'lib/theme'

import ColoredBanner from 'components/ColoredBanner/ColoredBanner'

import star from './star-rating.png'

type Props = { profileName: string }

const B2BColoredBanner = ({ profileName }: Props): JSX.Element => {
  const { t } = useTranslation()

  return (
    <ColoredBanner
      title={{
        text: t(
          'B2BColoredBanner.title',
          'Promote your business with {{profileName}}',
          { profileName },
        ),
      }}
      subtitle={{
        text: t('B2BColoredBanner.subtitle', 'Get in touch to find out more'),
      }}
      background={{
        color: tertiaryBlue700,
        image: { id: 'star', url: star },
      }}
      ctaButton={{
        label: {
          text: t('B2BColoredBanner.cta', 'Contact our team'),
        },
        link: config.B2B_PAGE_URL,
        borderColor: white,
        hoverStyle: {
          borderColor: white,
          labelColor: tertiaryBlue700,
          backgroundColor: white,
        },
      }}
    />
  )
}

export default B2BColoredBanner
